import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Modal, Row, Col, Upload, notification } from 'antd';
import { FILE_TEMPLATE_CODE } from 'helpers/constants';
import { excelFileUpload, downloadTemplateFile } from 'store/requests/definitions';

const ImportStoreBasedSection = ({
  onCloseHandler,
  batchExcelUrl,
  onSuccessCallback,
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [file, setFile] = useState(null);

  const [openImportModal, setOpenImportModal] = useState(false);

  useEffect(() => {
    showInfo();
  }, []);

  const props = {
    name: 'file',
    maxCount: 1,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || // .xlsx
        file.type === 'application/vnd.ms-excel'; // .xls

      if (!isExcel) {
        notification.error({ message: t('onlyAcceptExcel') });
        return false;
      }

      setFile(file);
      return false;
    },
  };

  const handleSubmit = async () => {
    if (!file) {
      notification.error({ message: t('selectFile') });
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append(
      'templateCode',
      FILE_TEMPLATE_CODE.STORE_CATEGORY_RANKING_CREATE_OR_UPDATE,
    );

    try {
      const res = await excelFileUpload(formData);
      if (res.error) {
        notification.error({ message: res.message });
      } else {
        notification.success({ message: t('fileUploadSuccess') });
        onSuccessCallback();
      }
    } catch (error) {
      notification.error({ message: t('fileUploadError') });
    } finally {
      setIsSubmitting(false);
      setOpenImportModal(false);
      onCloseHandler();
    }
  };

  const handleDownload = () => {
    downloadTemplateFile(batchExcelUrl)
  };

  const showInfo = () => {
    Modal.info({
      title: t('bulkAddAndUpdate'),
      content: t('importBasedSectionModalMessage'),
      onOk() {
        setOpenImportModal(true);
      },
    });
  };

  return (
    <>
      <Modal
        open={openImportModal}
        maskClosable={false}
        onOk={handleSubmit}
        onCancel={onCloseHandler}
        okButtonProps={{ loading: isSubmitting, disabled: !file }}
        title={t('bulkAddAndUpdate')}
        okText={t('save')}
        cancelText={t('cancel')}
        width={600}
      >
        <Row>
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div
              onClick={handleDownload}
              style={{
                width: '102px',
                height: '102px',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: 'lightgrey',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '1px',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <DownloadOutlined />
              </div>
              <div>
                <p style={{ margin: '5px', textAlign: 'center' }}>
                  {t('downloadExampleTemplate')}
                </p>
              </div>
            </div>
          </Col>
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Upload {...props}>
              <div
                style={{
                  width: '102px',
                  height: '102px',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  borderColor: 'lightgrey',
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '1px',
                  cursor: 'pointer',
                }}
              >
                <UploadOutlined />
                <p>{t('uploadReadyTemplate')}</p>
              </div>
            </Upload>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ImportStoreBasedSection;
